/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";

import { Layout } from "antd";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import ReservationForm from "./ReservationForm";

const { Content } = Layout;

const ReservationPage = () => {
  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <ReservationForm />
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default ReservationPage;
